import { Country } from '../../../utils/countryData';
import Input, { InputProps } from '../Input';
import { getPhoneNumber } from './getPhoneNumberValidator';

export type PhoneInputProps = Omit<InputProps, 'onChange'> & {
  onChange: (value: string) => void;
  defaultCountry?: Country;
};

const PhoneInput = ({ defaultCountry, onChange, onBlur, value, ...props }: PhoneInputProps) => (
  <Input
    {...props}
    value={value}
    type="tel"
    onChange={e => onChange(e.target.value)}
    onBlur={e => {
      onBlur?.(e);
      const phoneNumber = getPhoneNumber(e.target.value, defaultCountry);
      if (phoneNumber?.isValid()) {
        onChange(phoneNumber.formatInternational());
      }
    }}
  />
);

export default PhoneInput;
